import { actionLog } from "../../constants/actionTypes";

const requestActionLogs = (data) => ({
  type: actionLog.REQUEST_ACTION_LOGS,
  payload: data,
});

const successActionLogs = (data) => ({
  type: actionLog.SUCCESS_ACTION_LOGS,
  payload: data,
});

const errorActionLogs = (data) => ({
  type: actionLog.ERROR_ACTION_LOGS,
  payload: data,
});

const requestBetweenDatesLogs = (data) => ({
  type: actionLog.REQUEST_BETWEEN_DATES,
  payload: data,
});

const successBetweenDatesLogs = (data) => ({
  type: actionLog.SUCCESS_BETWEEN_DATES,
  payload: data,
});

const errorBetweenDatesLogs = (data) => ({
  type: actionLog.ERROR_BETWEEN_DATES,
  payload: data,
});

const requestActionLogDownload = (data) => ({
  type: actionLog.REQUEST_ACTION_LOG_DOWNLOAD,
  payload: data,
});

const successActionLogDownload = (data) => ({
  type: actionLog.SUCCESS_ACTION_LOG_DOWNLOAD,
  payload: data,
});

const errorActionLogDownload = (data) => ({
  type: actionLog.ERROR_ACTION_LOG_DOWNLOAD,
  payload: data,
});

export {
  requestActionLogs,
  successActionLogs,
  errorActionLogs,
  requestBetweenDatesLogs,
  successBetweenDatesLogs,
  errorBetweenDatesLogs,
  requestActionLogDownload,
  successActionLogDownload,
  errorActionLogDownload,
};
